import { render, staticRenderFns } from "./LogoutNotificationModal.vue?vue&type=template&id=bf13de18&scoped=true&"
import script from "./LogoutNotificationModal.vue?vue&type=script&lang=js&"
export * from "./LogoutNotificationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf13de18",
  null
  
)

export default component.exports